import { z } from 'zod';

export const getArticleSchema = z.object({
  article_id: z.uuid('Invalid article ID'),
});

export type GetArticlePayload = z.infer<typeof getArticleSchema>;
